export const boplEnabledFlag = typeof FLAG_BOPL_ENABLED !== 'undefined' ? FLAG_BOPL_ENABLED : false;
export const gtgtString =
  typeof GTGT_STRING !== 'undefined' ? GTGT_STRING : 'Guaranteed To Get There';
export const quickviewAutoSelectAttrDisabled =
  typeof FLAG_QV_AUTOSELECT_DISABLED !== 'undefined' ? FLAG_QV_AUTOSELECT_DISABLED : false;
